export class MutateOperation<T> {
  constructor(
    public readonly path: string,
    public readonly op: MutateOp = 'replace',
    public readonly payload?: T,
  ) {}
}

export type MutateOp = 'add' | 'replace' | 'remove';
